// removed by extract-text-webpack-plugin
module.exports = {"loader":"SFLoader__loader___1zEu-"};